// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>

import { path } from "static-path"

export const rootPath = path("/")
export const loginPath = path("/login")
export const signupPath = path("/signup")
export const credentialsLoginPath = path("/login/credentials")
export const detailsPath = path("/details")
export const profilePath = path("/profile")
export const profileEditPath = path("/profile/edit")
export const dashboardPath = path("/dashboard")
export const emailAuthPath = path("/auth/email/:email/:token/:clientAuthCode")
export const locationsPath = path("/locations")
export const locationEditPath = path("/locations/:id/edit")
export const adminPath = path("/admin")
export const adminLocationsPath = path("/admin/locations")
export const adminPlansPath = path("/admin/plans")
export const plansPath = path("/plans")
// Note: planEditPath was previously defined but likely intended for admin or generic use.
// Let's keep it but also add a specific user-facing one for clarity if needed,
// or confirm this existing one is intended for users. Assuming it is for now.
export const planEditPath = path("/plans/:id/edit")
export const planDetailsPath = path("/plans/:id")
